import { http } from '@/http'
import { dataShared } from '../store'
import { PdfCreate } from '@/utils/reports/generate-blob'
import { storeApp } from '@/store'

const PATH = 'transmission/'
const C_PREFIX = 'client/'

class SharedService {
  // modal grupos
  static async groups () {
    return http.get('auth/me/groups')
  }
  // data modal groups
  static async customerDataModalOpen (gId) {
    return http.get(`auth/me/group-by/${gId}`)
  }
  // export
  static async exportDataGroupBy (gId, name) {
    const url = `${process.env.VUE_APP_API_URL}auth/me/group-by/${gId}`
    const report = new PdfCreate(url)

    return await report.fetchExcelByItemId(gId, name)
  }

  // login
  static async me (data) {
    return http.get('auth/mecus', data)
  }

  static async login (data) {
    return http.post('auth/login', data)
  }

  static async signUp (data) {
    return http.post('auth/register', data)
  }

  // live
  static async getLiveById (id, lesson) {
    return http.get(PATH.concat('token/').concat(id).concat('/').concat(lesson))
  }

  static async checkToken (token) {
    return http.get('embed/' + token)
  }

  // notices
  static async getNotices () {
    return http.get(C_PREFIX.concat('notices'))
  }

  static async getCollect () {
    return http.get(C_PREFIX.concat('noticesCollect'))
  }

  // events
  static async getEvents () {
    return http.get(C_PREFIX.concat('events'))
  }

  static async nextEvents () {
    return http.get(C_PREFIX.concat('next-events'))
  }

  static async getEventById (eventId) {
    return http.get(C_PREFIX.concat('event-by/').concat(eventId))
  }

  static async eventsByCustomer (id) {
    return http.get(C_PREFIX.concat('events-by-customer/').concat(id))
  }

  static async checkAccess () {
    return http.get(C_PREFIX.concat('events'))
  }

  // verifica se o usuário tem acesso
  static async watchEventById (id) {
    const cId = dataShared.getters.getDataByUserLogged

    const headers = {
      headers: {
        customerId: cId?.id
      }
    }

    return http.get(C_PREFIX.concat('check-access-by/').concat(id).concat('/event'), headers)
  }

  // define o modulo ativo com as aulas e perguntas
  static async activeModulePlaying (eventId) {
    return http.get(C_PREFIX.concat('module/').concat(eventId).concat('/outline?format=nested&with_options=true'))
  }

  static async getModuleId() {
    
  }

  // home
  static async getCarroussel () {
    return http.get('app/get-carroussel')
  }

  static async getMainDesc () {
    return http.get('app/get-main-desc')
  }

  static async getMainEvent () {
    return http.get('app/get-mainEvent')
  }

  static async getHighlights () {
    return http.get('app/get-highlights')
  }

  static async getBannerLogin () {
    return http.get('app/get-banner')
  }

  // profile
  static async getCustomerInfo (id) {
    return http.get(`app/customer-by/${id}`)
  }

  static async beAFighter (id) {
    return http.get(C_PREFIX.concat(`be-a-fighter/${id}`))
  }

  static async updateData (data) {
    const cId = dataShared.getters.getDataByUserLogged
    const d = { ...data, cId: cId?.id }

    return http.post('update-data', d)
  }

  // purchase
  static async setSponsorshipPage (fighter, secret) {
    return http.get(C_PREFIX.concat(`check/${fighter}/${secret}`))
  }

  static async validityCoupon (coupon) {
    return http.get(C_PREFIX.concat(`validity-coupon/${coupon}`))
  }

  static async initiate (id, couponId = null) { // payment
    const cId = dataShared.getters.getDataByUserLogged

    const data = {
      event_id: id,
      customer_id: cId?.id,
      __coupon_id: couponId
    }

    return http.post('payments/initiate', data)
  }

  // status
  static async getTrainingProgress (trainingId) {
    const cId = dataShared.getters.getDataByUserLogged
    
    const headers = {
      headers: {
        customerId: cId?.id
      }
    }

    console.log(headers);

    return http.get(C_PREFIX.concat('trainings/').concat(trainingId).concat('/progress'), headers)
  }

  static async postLessonAnswer (lessonId, payload) {
    const cId = dataShared.getters.getDataByUserLogged
    
    const headers = {
      headers: {
        customerId: cId?.id
      }
    }

    return http.post(C_PREFIX.concat('lessons/').concat(lessonId).concat('/answers'), payload, headers)
  }

  // finalizar tentativa no fim do vídeo - próxima aula
  static async finalizeLesson (lessonId, groupId) {
    const cId = dataShared.getters.getDataByUserLogged
    
    const headers = {
      headers: {
        customerId: cId?.id,
        group: groupId
      }
    }

    return http.post(C_PREFIX.concat('lessons/').concat(lessonId).concat('/finalize'), {}, headers)
  }

}

export default SharedService
